module.exports = __webpack_public_path__ + "img/emptytest.58d3ca2e.svg";